import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { Button, InlineAlert } from '@/contasis';
import { useRetroalimentacion } from '../hooks/useRetroalimentacion';
import type { FlujoCapturaRetroalimentacion } from '../tipos';
import { BuzonIdeas } from './BuzonIdeas';
import { EncuestaNps } from './EncuestaNps';
import { EstadoAnimoDiario } from './EstadoAnimoDiario';

interface ModalRetroalimentacionObligatoriaProps {
  flujo: FlujoCapturaRetroalimentacion;
  onContinuar: () => void;
}

export function ModalRetroalimentacionObligatoria({ flujo, onContinuar }: ModalRetroalimentacionObligatoriaProps) {
  const { contadorEnvios } = useRetroalimentacion();
  const contadorInicial = useRef(contadorEnvios);
  const completado = contadorEnvios > contadorInicial.current;

  return createPortal(
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="retroalimentacion-obligatoria-titulo"
    >
      <div className="max-h-[90vh] w-full max-w-xl overflow-y-auto rounded-2xl border border-default bg-surface-0 p-6 shadow-xl">
        {completado ? (
          <div className="space-y-5">
            <InlineAlert variant="success" title="¡Gracias! Tu retroalimentación de este mes quedó registrada" />
            <div className="flex justify-end">
              <Button variant="primary" onClick={onContinuar}>
                Continuar
              </Button>
            </div>
          </div>
        ) : (
          <div className="space-y-5">
            <div className="space-y-1">
              <h2 id="retroalimentacion-obligatoria-titulo" className="text-h4 font-display text-primary">
                Tu opinión de este mes
              </h2>
              <p className="text-ui-sm text-tertiary">
                Una vez al mes necesitamos tu retroalimentación para seguir mejorando SenciYo. Solo toma un minuto.
              </p>
            </div>

            {flujo === 'buzon_ideas' && <BuzonIdeas />}
            {flujo === 'nps' && <EncuestaNps />}
            {flujo === 'estado_animo' && <EstadoAnimoDiario />}
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
}
